import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import BASE_URL from "../config";
import SidebarRFQ from "../POpage/SidebarRFQ";
import Select from "react-select";


const CreateRFQ = () => {
  const [file, setFile] = useState(null);
  const [file1, setFile1] = useState(null);
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("userdata"));


  const [formData, setFormData] = useState({
    rfq_number: "",
    rfq_date: "",
    client_name: "",
    client_contact: "",
    client_email: "",
    closing_date: "",
    products: "",
    status: "",
    bid_status: "",
    quote_submit_date: "",
    assigned_staff: "",
    client_feedback: "",
    manufacturer_supplier: "",
    if_lost: "",
    status_feedback: "",
    latest_update: "",
  });
  const [clients, setClients] = useState([]);
  const [suppiler, setSupplier] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    fetchClients();
    fetchSupplier();
  }, []);

  const fetchClients = () => {
    axios
      .get(`${BASE_URL}/api/client-get`)
      .then((res) => {
        setClients(res.data);
      })
      .catch((err) => {
        console.error("Error fetching clients:", err);
      });
  };

  const fetchSupplier = () => {
    axios
      .get(`${BASE_URL}/api/supplier-get`)
      .then((res) => {
        setSupplier(res.data);
      })
      .catch((err) => {
        console.error("Error fetching clients:", err);
      });
  };

  const templateDownload = () => {
    const link = document.createElement("a");
    link.href = `${process.env.PUBLIC_URL}/RFQ Template.xlsx`;
    link.download = "RFQ Template.xlsx";
    link.click();
  };
 const handleChangecreate = (nameOrEvent, selectedOption) => {
  // ✅ Case 1: Handle normal inputs (text, date, number, etc.)
  if (typeof nameOrEvent === "object" && nameOrEvent.target) {
    const { name, value } = nameOrEvent.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    return;
  }

  // ✅ Case 2: Handle react-select dropdowns
  const name = nameOrEvent;
  const value = selectedOption?.value || "";

  // Handle "Add New" navigation cases
  if (name === "manufacturer_supplier" && value === "add_new") {
    navigate("/supplier");
    return;
  }
  if (name === "client_name" && value === "add_new") {
    navigate("/clientadd");
    return;
  }

  // Update formData for dropdowns
  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));
};


  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setMessage("");
  };

  const handleSubmit = async () => {
    const sendData = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      sendData.append(key, value);
    });
    if (file1) {
      sendData.append("rfq_attachment", file1);
    }

    if (file) {
      sendData.append("file", file);
    }

    try {
      const res = await axios.post(`${BASE_URL}/api/craeterfqdata`, sendData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      });
      navigate("/listrfq");
      handleSubmitCreateRFQ()
      Swal.fire(
        "Success",
        res.data.message || "RFQ submitted successfully",
        "success"
      );
      setFormData({
        rfq_number: "",
        rfq_date: "",
        client_name: "",
        client_contact: "",
        client_email: "",
        closing_date: "",
        products: "",
        status: "",
        bid_status: "",
        quote_submit_date: "",
        assigned_staff: "",
        client_feedback: "",
        manufacturer_supplier: "",
        if_lost: "",
      });
      setFile(null);
    } catch (err) {
      console.error(err);
      Swal.fire(
        "Error",
        err.response?.data?.message || "Submission failed",
        "error"
      );
    }
  };

  const handleUpload = async () => {
    if (!file) {
      Swal.fire("Please select a file");
      return;
    }

    const formDataUpload = new FormData();
    formDataUpload.append("file", file);

    try {
      setUploading(true);
      const res = await axios.post(
        `${BASE_URL}/api/rfqimport-excel`,
        formDataUpload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
          },
        }
      );
      handleSubmitCreateImport()
      setMessage("✅ File uploaded successfully!");
      navigate("/listrfq");
      Swal.fire(res.data.message || "RFQ File upload successfully");
    } catch (error) {
      console.error("Upload failed:", error.response?.data);
      setMessage("❌ File upload failed.");
      setUploading(false);
    }
  };



  
     const handleSubmitCreateRFQ = async () => {
      try {
        const response = await axios.post('https://bimanager.nexteck.uk/api/messages', 
          {
            user_id:user.id,
            type:"RFQ",
            message:"New RFQ Created",
            status:"0"
          }
        );
        console.log(response.data);
      
      } catch (error) {
        console.error(error);
       
      }
    };
  
  
     const handleSubmitCreateImport = async () => {
      try {
        const response = await axios.post('https://bimanager.nexteck.uk/api/messages', 
          {
            user_id:user.id,
            type:"RFQ",
            message:"New RFQ Import xlsx File",
            status:"0"
          }
        );
        console.log(response.data);
      
      } catch (error) {
        console.error(error);
       
      }
    };

  return (
    <div className="row">
      <div className="custom-2-5">
        <SidebarRFQ />
      </div>
      <div className="custom-9-5 dashboardsclooer p-4 ">
        <div
          className="card p-4 mt-1 shadow"
          style={{ backgroundColor: "#fff" }}
        >
          <div className="row">
            <div className="col-lg-9">
              <h5 className="mb-3">CREATE RFQ DETAILS</h5>
            </div>
            <div className="col-lg-3">
              <button className="btn btncolor" onClick={templateDownload}>
                {" "}
                Demo Template Download
              </button>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12 p-2">
              <label>
                <strong>Import xlsx File</strong>
                <div className="accepted-formats">
                  <h6>
                    <i className="fas fa-info-circle"></i> Accepted File Formats
                  </h6>
                  <div className="format-list">
                    <span className="format-tag">.xlsx</span>
                    <span className="format-tag">.xls</span>
                    <span className="format-tag">.csv</span>
                  </div>
                </div>
              </label>
              <br />

              <div className="upload-section" id="uploadSection">
                <input
                  type="file"
                  className="file-input"
                  id="fileInput"
                  accept=".xls,.xlsx,.csv"
                  onChange={handleFileChange}
                />
                <div className="upload-icon">
                  <i className="fas fa-cloud-upload-alt"></i>
                </div>
                <div className="upload-text">
                  <strong>Click to upload</strong> or drag and drop
                </div>
                <div className="upload-subtext">Maximum file size: 10MB</div>
              </div>

              {file && (
                <div className="file-info mt-2">
                  <div className="file-name">{file.name}</div>
                  <div className="file-size">
                    {(file.size / 1024 / 1024).toFixed(2)} MB
                  </div>
                </div>
              )}

              {message && <div className="mt-2">{message}</div>}

             <div className="mt-3 d-flex justify-content-end">
  <button
    className="btn btncolor end-text"
    onClick={handleUpload}
    disabled={!file || uploading}
  >
    {uploading ? "Uploading..." : "Upload"}
  </button>
</div>
            </div>
          </div>
          <h2 className="text-center">OR</h2>

          <div className="row mt-4 p-3">
            <div className="form-group mb-3 col-lg-4">
              <label>
                <strong>RFQ Attachment</strong>
              </label>
              <br />
              <input
                type="file"
                onChange={(e) => setFile1(e.target.files[0])}
              />
            </div>
            {[
              { label: "RFQ Number*", name: "rfq_number" },
              { label: "RFQ Received Date*", name: "rfq_date", type: "date" },
            ].map(({ label, name, type = "text" }) => (
              <div className="form-group mb-3 col-lg-4" key={name}>
                <label>
                  <strong>{label}</strong>
                </label>
                <input
                  type={type}
                  name={name}
                  className="form-control"
                  value={formData[name]}
                  onChange={handleChangecreate}
                />
              </div>
            ))}

            {/* <div className="form-group mb-3 col-lg-4">
              <label>
                <strong>Client Name*</strong>
              </label>
              <select
                name="client_name"
                className="form-control"
                value={formData.client_name}
                onChange={handleChangecreate}
              >
                <option value="">Select Client</option>
                {clients.map((client, index) => (
                  <option key={index} value={client.client_name}>
                    {client.client_name}
                  </option>
                ))}

                <option value="add_new">
                  <button className="btn btn-primary">New Add</button>
                </option>
              </select>
            </div> */}

              <div className="form-group mb-3 col-lg-4">
                  <label>
                    <strong>Client Name*</strong>
                  </label>
                  <Select
                    name="client_name"
                    value={
                      formData.client_name
                        ? { label: formData.client_name, value: formData.client_name }
                        : null
                    }
                    onChange={(selectedOption) =>
                      handleChangecreate("client_name", selectedOption)
                    }
                    options={[
                      ...clients.map((c) => ({
                        label: c.client_name,
                        value: c.client_name,
                      })),
                      { label: "➕ Add New Client", value: "add_new" },
                    ]}
                    placeholder="Search or select client"
                    isSearchable
                    classNamePrefix="react-select"
                  />
                </div>

            {/* <div className="form-group mb-3 col-lg-4"> */}
              {/* <label>
                <strong>Manufacturer/Supplier</strong>
              </label> */}
              {/* <select
                name="manufacturer_supplier"
                className="form-control"
                value={formData.manufacturer_supplier}
                onChange={handleChangecreate}
              >
                <option value="">Select Supplier</option>
                {suppiler.map((client, index) => (
                  <option key={index} value={client.name}>
                    {client.name}
                  </option>
                ))}
                <option value="add_new">
                  <button className="btn btn-primary">New Add</button>
                </option>
              </select> */}

               {/* <Select
                      name="manufacturer_supplier"
                      value={
                        formData.manufacturer_supplier
                          ? { label: formData.manufacturer_supplier, value: formData.manufacturer_supplier }
                          : null
                      }
                      onChange={(selectedOption) =>
                        handleChangecreate("manufacturer_supplier", selectedOption)
                      }
                      options={[
                        ...suppiler.map((s) => ({
                          label: s.name,
                          value: s.name,
                        })),
                        { label: "➕ Add New Supplier", value: "add_new" },
                      ]}
                      placeholder="Search or select supplier"
                      isSearchable
                      classNamePrefix="react-select"
                    /> */}
            {/* </div> */}

            {[
              { label: "Manufacturer/Supplier", name: "manufacturer_supplier", placeholder:"Search or select supplier" },
              { label: "Client Contact", name: "client_contact", placeholder:"Client Contact" },
              { label: "Client Email", name: "client_email" , placeholder:"Client Email" },
              {
                label: "RFQ Closing Date*",
                name: "closing_date",
                type: "date",
                placeholder:"RFQ Closing Date"
              },
              { label: "Item Description", name: "products", placeholder:"description" },
              {
                label: "Quote Submit Date",
                name: "quote_submit_date",
                type: "date",
                placeholder:"Quote Submit Date"
              },
              // { label: "Manufacturer/Supplier", name: "manufacturer_supplier" },
              { label: "Assigned Staff", name: "assigned_staff"  , placeholder:"Assigned Staff" },
              { label: "Latest Update", name: "latest_update" , placeholder:"Latest Update" },
              { label: "Client Feedback", name: "client_feedback"  , placeholder:"Client Feedback" },
            ].map(({ label, name, type = "text" ,placeholder}) => (
              <div className="form-group mb-3 col-lg-4" key={name}>
                <label>
                  <strong>{label}</strong>
                </label>
                <input
                  type={type}
                  name={name}
                  className="form-control"
                  value={formData[name]}
                  onChange={handleChangecreate}
                  placeholder={placeholder}
                />
              </div>
            ))}

            {/* Dropdowns */}
            <div className="form-group mb-3 col-lg-4">
              <label>
                <strong>Status</strong>
              </label>
              <select
                name="status"
                className="form-control"
                value={formData.status}
                onChange={handleChangecreate}
              >
                <option value="">Select</option>
                <option>RFQ Sent</option>
                <option>Supplier Quote received</option>
                <option>Quote submitted to Client</option>
                <option>Quote not Received From Supplier</option>
                <option>Under clarification</option>
              </select>
            </div>
            {formData.status && (
              <div className="form-group mb-3 col-lg-4">
                <label>
                  <strong>Current Remark</strong>
                </label>
                <input
                  type="text"
                  name="status_feedback"
                  className="form-control"
                  value={formData.status_feedback || ""}
                  onChange={handleChangecreate}
                />
              </div>
            )}

            <div className="form-group mb-3 col-lg-4">
              <label>
                <strong>Bid Status</strong>
              </label>
              <select
                name="bid_status"
                className="form-control"
                value={formData.bid_status}
                onChange={handleChangecreate}
              >
                <option value="">Select</option>
                <option>Won</option>
                <option>Lost</option>
                <option>Onhold</option>
                <option>In-Progress</option>
              </select>
            </div>

            <div className="form-group mb-3 col-lg-4">
              <label>
                <strong>If Lost</strong>
              </label>
              <select
                name="if_lost"
                className="form-control"
                value={formData.if_lost}
                onChange={handleChangecreate}
              >
                <option value="">Select</option>
                <option>Price</option>
                <option>Technical</option>
                <option>Other</option>
              </select>
            </div>
          </div>
          <div className="text-center">
            <button className="btn btncolor w-50 mt-2" onClick={handleSubmit}>
              Submit RFQ
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateRFQ;
